export default class LatLngPoint {
    constructor(
        lat: number,
        lng: number) {
            this.lat = lat
            this.lng = lng
        }

    lat: number
    lng: number

    toJsonObject(): any {
        return {
            lat: this.lat,
            lng: this.lng
        }
    }
}
